import {
  ICreateSftpPartnerRequest,
  ISetSftpPartnerEnabledRequest,
  ISftpPartnerDetailResponse,
  ISftpPartnerListResponse,
  IUpdateSftpPartnerRequest,
} from "types/SftpPartner";

import { api } from ".";

// SFTP ingestion partners — SuperAdmin only (Integrations → SFTP).
const sftpPartnerQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getSftpPartners: builder.query<ISftpPartnerListResponse, void>({
      query: () => ({
        url: "/integration/sftp/partners",
        method: "GET",
      }),
      providesTags: [{ type: "SftpPartners", id: "LIST" }],
    }),
    getSftpPartner: builder.query<ISftpPartnerDetailResponse, string>({
      query: (slug) => ({
        url: `/integration/sftp/partners/${encodeURIComponent(slug)}`,
        method: "GET",
      }),
      providesTags: (_result, _error, slug) => [
        { type: "SftpPartners", id: slug },
      ],
    }),
    // Enable / disable: the server accepts `enabled` and nothing else on PATCH.
    setSftpPartnerEnabled: builder.mutation<
      ISftpPartnerDetailResponse,
      ISetSftpPartnerEnabledRequest
    >({
      query: ({ slug, enabled }) => ({
        url: `/integration/sftp/partners/${encodeURIComponent(slug)}`,
        method: "PATCH",
        body: { enabled },
      }),
      invalidatesTags: (_result, _error, { slug }) => [
        { type: "SftpPartners", id: "LIST" },
        { type: "SftpPartners", id: slug },
      ],
    }),
    // Create a partner (always PUSH, always disabled).
    createSftpPartner: builder.mutation<
      ISftpPartnerDetailResponse,
      ICreateSftpPartnerRequest
    >({
      query: (body) => ({
        url: "/integration/sftp/partners",
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { slug }) => [
        { type: "SftpPartners", id: "LIST" },
        { type: "SftpPartners", id: slug },
      ],
    }),
    // Edit prefix, account, include tokens and mapping rules.
    updateSftpPartner: builder.mutation<
      ISftpPartnerDetailResponse,
      IUpdateSftpPartnerRequest
    >({
      query: ({ slug, body }) => ({
        url: `/integration/sftp/partners/${encodeURIComponent(slug)}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { slug }) => [
        { type: "SftpPartners", id: "LIST" },
        { type: "SftpPartners", id: slug },
      ],
    }),
  }),
});

export const {
  useGetSftpPartnersQuery,
  useGetSftpPartnerQuery,
  useSetSftpPartnerEnabledMutation,
  useCreateSftpPartnerMutation,
  useUpdateSftpPartnerMutation,
} = sftpPartnerQueries;
